import {
	PropositionProductTypeValues,
	PropositionProductType,
	PropositionStatus,
	PropositionDetails,
	PropositionStatusValues,
	propositionDocumentTypeEnum,
	PropositionDocumentType,
} from "../propositions/propositions.types";
import { PaginatedResponse } from "../common/pagination.types";
import type { Prisma } from "@prisma/client";
import { propositionDetailsSelect } from "@dune/vars";

export const ContractStatus = {
	CONTRACT_NEW: PropositionStatus.CONTRACT_NEW,
	CONTRACT_TO_SIGN: PropositionStatus.CONTRACT_TO_SIGN,
	CONTRACT_ONGOING: PropositionStatus.CONTRACT_ONGOING,
	CONTRACT_WARRANTY: PropositionStatus.CONTRACT_WARRANTY, 
	CONTRACT_TERMINATED: PropositionStatus.CONTRACT_TERMINATED,
} as const satisfies Partial<Record<PropositionStatusValues, PropositionStatusValues>>;

export const contractStatusValues = Object.values(ContractStatus)

export type ContractStatusValues = typeof contractStatusValues[number];

export const isContractStatus = (status: unknown): status is ContractStatusValues =>
	contractStatusValues.includes(status as ContractStatusValues);

export type Contract = Prisma.PropositionGetPayload<{
	select: typeof propositionDetailsSelect;
}>;

export interface ContractFilters {
	productType?: PropositionProductTypeValues;
	status?: ContractStatusValues;
	constructionSiteId?: number;
	brokerSocietyId?: number;
	search?: string;
	page?: number;
	limit?: number;
	sortBy?: string;
	sortOrder?: "asc" | "desc";
}

export interface SignContractDto {
	signedAt?: Date;
	contractStartDate?: Date;
	contractEndDate?: Date;
	contractNumber?: string;
}

export interface UpdateContractDto {
	assureurName?: string;
	primeTTC?: number;
	remunerationApporteur?: number;
	contractStartDate?: Date;
	contractEndDate?: Date;
	contractNumber?: string;
}

export type ContractsList = PaginatedResponse<Contract>;

export interface ContractCounts {
	statusCounts: Record<string, number>;
	productTypeCounts: Record<string, number>;
	totalContracts: number;
}


export type ContractDetails = PropositionDetails;

export type ContractProductType = PropositionProductTypeValues;
export const ContractProductTypeValues = PropositionProductType;

export const contractDocumentTypeEnum = propositionDocumentTypeEnum;

export type ContractDocumentType = PropositionDocumentType;

export interface ContractAction {
	type: "SIGN" | "UPDATE" | "RENEW" | "TERMINATE";
	contractId: number;
	data?: any;
}

export interface ContractStats {
	totalContracts: number;
	contractsByProductType: Record<string, number>;
	contractsByMonth: Record<string, number>;
	activeContracts: number;
	expiredContracts: number;
	expiringContracts: number;
}

export interface ContractReport {
	id: number;
	contractNumber: string;
	reference: string;
	productType: ContractProductType;
	constructionSiteName: string;
	brokerSocietyName: string;
	assureurName: string;
	primeTTC: number;
	remunerationApporteur: number;
	signedAt: Date;
	contractStartDate?: Date;
	contractEndDate?: Date;
	status: "ACTIVE" | "EXPIRED" | "EXPIRING";
}

export interface ContractNotification {
	id: number;
	contractId: number;
	type: "EXPIRING" | "EXPIRED" | "PAYMENT_DUE" | "RENEWAL_AVAILABLE";
	message: string;
	createdAt: Date;
	read: boolean;
}

export type { Proposition, PropositionDocument } from "../propositions/propositions.types";
